<!-- SPEC-webplanner-052 — SHA presenter alert card, SHA-SPEC §3.3 structure.
     icon + one-sentence message + italicized script + Dismiss. message/script
     rendered VERBATIM from the payload (copy discipline); script line is
     omitted entirely when the payload carries no script (poll leg has none). -->
<div
    *ngIf="visibleAlert"
    class="sha-alert"
    [ngClass]="'sha-alert--' + severityClass"
    role="alert"
    aria-live="assertive"
>
    <div class="sha-alert__row">
        <!-- §3.2 icon: error circle for Red, warning triangle for Yellow/Orange -->
        <span class="sha-alert__icon" aria-hidden="true">
            <ng-container *ngIf="isErrorCircle; else warningTriangle">
                <!-- error circle -->
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
            </ng-container>
            <ng-template #warningTriangle>
                <!-- warning triangle -->
                <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                    <line x1="12" y1="9" x2="12" y2="13"></line>
                    <line x1="12" y1="17" x2="12.01" y2="17"></line>
                </svg>
            </ng-template>
        </span>

        <div class="sha-alert__body">
            <!-- one-sentence plain-language description — verbatim -->
            <p class="sha-alert__message" *ngIf="visibleAlert.message">{{ visibleAlert.message }}</p>

            <!-- suggested action, phrased as a script, in italics — verbatim.
                 Omitted when absent (poll leg carries no script; never invent). -->
            <p class="sha-alert__script" *ngIf="visibleAlert.script">{{ visibleAlert.script }}</p>
        </div>
    </div>

    <div class="sha-alert__actions">
        <button type="button" class="sha-alert__dismiss" (click)="onDismiss()">Dismiss</button>
    </div>
</div>
